import * as React from "react";

export const SvgPending = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9.67 3v1.71m0 9.067v2.736M5.394 9.671H2.999m13 0h-1.026m-.885 4.418-.484-.484m.626-8.439-.968.968m-8.435 8.38 1.935-1.935M4.97 5.025 6.42 6.476"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.863}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
